import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

interface ClassItem {
  time: string;
  subject: string;
  teacher: string;
  room: string;
}

interface ScheduleData {
  [date: string]: ClassItem[];
}

const ParentSchedule = () => {
  const routes = all_routes;

  const [children] = useState([
    { id: "1", name: "Emma Johnson", grade: "10th", class: "10-A" },
    { id: "2", name: "James Johnson", grade: "8th", class: "8-B" },
  ]);

  const [selectedChildId, setSelectedChildId] = useState("1");
  const [viewType, setViewType] = useState<"daily" | "weekly">("weekly");
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const selectedChild = children.find((child) => child.id === selectedChildId);

  // Mock schedule data with dates
  const scheduleData: ScheduleData = {
    "2024-08-12": [
      {
        time: "8:30 - 9:15",
        subject: "Mathematics",
        teacher: "Mrs. Smith",
        room: "Room 101",
      },
      {
        time: "9:30 - 10:15",
        subject: "English",
        teacher: "Mr. Brown",
        room: "Room 205",
      },
      {
        time: "10:30 - 11:15",
        subject: "Science",
        teacher: "Dr. Wilson",
        room: "Lab 1",
      },
      {
        time: "11:30 - 12:15",
        subject: "History",
        teacher: "Ms. Davis",
        room: "Room 303",
      },
      {
        time: "1:00 - 1:45",
        subject: "Physical Education",
        teacher: "Coach Johnson",
        room: "Gym",
      },
    ],
    "2024-08-13": [
      {
        time: "8:30 - 9:15",
        subject: "Science",
        teacher: "Dr. Wilson",
        room: "Lab 1",
      },
      {
        time: "9:30 - 10:15",
        subject: "Mathematics",
        teacher: "Mrs. Smith",
        room: "Room 101",
      },
      {
        time: "10:30 - 11:15",
        subject: "Art",
        teacher: "Ms. Garcia",
        room: "Art Studio",
      },
      {
        time: "11:30 - 12:15",
        subject: "English",
        teacher: "Mr. Brown",
        room: "Room 205",
      },
      {
        time: "1:00 - 1:45",
        subject: "Music",
        teacher: "Mr. Martinez",
        room: "Music Room",
      },
    ],
    "2024-08-14": [
      {
        time: "8:30 - 9:15",
        subject: "History",
        teacher: "Ms. Davis",
        room: "Room 303",
      },
      {
        time: "9:30 - 10:15",
        subject: "Mathematics",
        teacher: "Mrs. Smith",
        room: "Room 101",
      },
      {
        time: "10:30 - 11:15",
        subject: "Science",
        teacher: "Dr. Wilson",
        room: "Lab 1",
      },
      {
        time: "11:30 - 12:15",
        subject: "Geography",
        teacher: "Mr. Taylor",
        room: "Room 202",
      },
      {
        time: "1:00 - 1:45",
        subject: "Computer Science",
        teacher: "Ms. Lee",
        room: "Computer Lab",
      },
    ],
    "2024-08-15": [
      {
        time: "8:30 - 9:15",
        subject: "English",
        teacher: "Mr. Brown",
        room: "Room 205",
      },
      {
        time: "9:30 - 10:15",
        subject: "Science",
        teacher: "Dr. Wilson",
        room: "Lab 1",
      },
      {
        time: "10:30 - 11:15",
        subject: "Mathematics",
        teacher: "Mrs. Smith",
        room: "Room 101",
      },
      {
        time: "11:30 - 12:15",
        subject: "Physical Education",
        teacher: "Coach Johnson",
        room: "Gym",
      },
      {
        time: "1:00 - 1:45",
        subject: "Art",
        teacher: "Ms. Garcia",
        room: "Art Studio",
      },
    ],
    "2024-08-16": [
      {
        time: "8:30 - 9:15",
        subject: "Mathematics",
        teacher: "Mrs. Smith",
        room: "Room 101",
      },
      {
        time: "9:30 - 10:15",
        subject: "History",
        teacher: "Ms. Davis",
        room: "Room 303",
      },
      {
        time: "10:30 - 11:15",
        subject: "English",
        teacher: "Mr. Brown",
        room: "Room 205",
      },
      {
        time: "11:30 - 12:15",
        subject: "Science",
        teacher: "Dr. Wilson",
        room: "Lab 1",
      },
      {
        time: "1:00 - 1:45",
        subject: "Study Hall",
        teacher: "Various",
        room: "Library",
      },
    ],
  };

  const getWeekDates = (date: string) => {
    const d = new Date(date);
    const day = d.getDay();
    const diff = d.getDate() - day;
    const sunday = new Date(d.setDate(diff));

    const weekDates = [];
    for (let i = 1; i <= 5; i++) {
      // Monday to Friday
      const weekDay = new Date(sunday);
      weekDay.setDate(sunday.getDate() + i);
      weekDates.push(weekDay.toISOString().split("T")[0]);
    }
    return weekDates;
  };

  const getSubjectColor = (subject: string) => {
    const colors: any = {
      Mathematics: "primary",
      English: "success",
      Science: "info",
      History: "warning",
      "Physical Education": "danger",
      Art: "purple",
      Music: "pink",
      "Computer Science": "dark",
      Geography: "secondary",
    };
    return colors[subject] || "light";
  };

  const formatDateHeader = (date: string) => {
    return new Date(date).toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const getDayName = (date: string) => {
    return new Date(date).toLocaleDateString("en-US", { weekday: "long" });
  };

  const renderDailySchedule = () => {
    const daySchedule = scheduleData[selectedDate] || [];

    return (
      <div className="card">
        <div className="card-header">
          <h5 className="card-title mb-0">{formatDateHeader(selectedDate)}</h5>
        </div>
        <div className="card-body">
          {daySchedule.length > 0 ? (
            <div className="timeline-schedule">
              {daySchedule.map((classItem: ClassItem, index: number) => (
                <div
                  key={index}
                  className="row align-items-center p-3 mb-3 border rounded"
                >
                  <div className="col-md-2">
                    <div className="time-block text-center">
                      <strong className="d-block">
                        {classItem.time.split(" - ")[0]}
                      </strong>
                      <small className="text-muted">
                        {classItem.time.split(" - ")[1]}
                      </small>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="class-info">
                      <h6 className="mb-1">
                        <span
                          className={`badge bg-${getSubjectColor(
                            classItem.subject
                          )} me-2`}
                        >
                          {classItem.subject}
                        </span>
                      </h6>
                      <p className="text-muted mb-0">
                        {classItem.teacher} • {classItem.room}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="d-flex gap-2">
                      <button className="btn btn-outline-primary btn-sm">
                        <i className="ti ti-message me-1"></i>Contact Teacher
                      </button>
                      <button className="btn btn-outline-info btn-sm">
                        <i className="ti ti-book me-1"></i>Materials
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-4">
              <div className="avatar avatar-xl bg-secondary-transparent mb-3">
                <i className="ti ti-calendar-x fs-1 text-secondary"></i>
              </div>
              <h5>No classes scheduled</h5>
              <p className="text-muted">
                No classes found for the selected date.
              </p>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderWeeklySchedule = () => {
    const weekDates = getWeekDates(selectedDate);

    return (
      <div className="row">
        {weekDates.map((date) => {
          const daySchedule = scheduleData[date] || [];
          return (
            <div key={date} className="col-md-6 col-lg-4 mb-4">
              <div className="card">
                <div className="card-header bg-primary text-white">
                  <h6 className="mb-0">{getDayName(date)}</h6>
                  <small className="opacity-75">
                    {new Date(date).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                    })}
                  </small>
                </div>
                <div className="card-body p-2">
                  {daySchedule.length > 0 ? (
                    daySchedule.map((classItem: ClassItem, index: number) => (
                      <div key={index} className="mb-2 p-2 border rounded">
                        <div className="d-flex justify-content-between align-items-start mb-1">
                          <span
                            className={`badge bg-${getSubjectColor(
                              classItem.subject
                            )}`}
                          >
                            {classItem.subject}
                          </span>
                          <small className="text-muted">{classItem.time}</small>
                        </div>
                        <p className="mb-1 fw-semibold">{classItem.teacher}</p>
                        <small className="text-muted">{classItem.room}</small>
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-3 text-muted">
                      <i className="ti ti-calendar-off mb-2 d-block"></i>
                      <small>No classes</small>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const navigateDate = (direction: "prev" | "next") => {
    const currentDate = new Date(selectedDate);
    const days =
      viewType === "weekly"
        ? direction === "next"
          ? 7
          : -7
        : direction === "next"
        ? 1
        : -1;
    currentDate.setDate(currentDate.getDate() + days);
    setSelectedDate(currentDate.toISOString().split("T")[0]);
  };

  const goToToday = () => {
    setSelectedDate(new Date().toISOString().split("T")[0]);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="row mb-4">
            <div className="col">
              <div className="d-flex align-items-center">
                <Link
                  to={routes.parentMenu}
                  className="btn btn-outline-secondary btn-sm me-3"
                >
                  <i className="ti ti-arrow-left"></i>
                </Link>
                <div>
                  <h3 className="page-title mb-1">Full Schedule</h3>
                  <p className="text-muted mb-0">
                    Daily & weekly schedule view
                  </p>
                </div>
              </div>
            </div>
            <div className="col-auto">
              {children.length > 1 && (
                <div className="dropdown">
                  <button
                    className="btn btn-outline-primary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-user me-2"></i>
                    {selectedChild?.name}
                  </button>
                  <ul className="dropdown-menu">
                    {children.map((child) => (
                      <li key={child.id}>
                        <button
                          className={`dropdown-item ${
                            selectedChildId === child.id ? "active" : ""
                          }`}
                          onClick={() => setSelectedChildId(child.id)}
                        >
                          {child.name} - {child.grade} {child.class}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>

          {/* Controls */}
          <div className="row mb-4">
            <div className="col-md-3">
              <label className="form-label">Select Date</label>
              <input
                type="date"
                className="form-control"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <label className="form-label">View Type</label>
              <div className="btn-group w-100">
                <button
                  className={`btn ${
                    viewType === "daily" ? "btn-primary" : "btn-outline-primary"
                  }`}
                  onClick={() => setViewType("daily")}
                >
                  Daily
                </button>
                <button
                  className={`btn ${
                    viewType === "weekly"
                      ? "btn-primary"
                      : "btn-outline-primary"
                  }`}
                  onClick={() => setViewType("weekly")}
                >
                  Weekly
                </button>
              </div>
            </div>
            <div className="col-md-3">
              <label className="form-label">Navigation</label>
              <div className="btn-group w-100">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => navigateDate("prev")}
                >
                  <i className="ti ti-chevron-left"></i> Previous
                </button>
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => navigateDate("next")}
                >
                  Next <i className="ti ti-chevron-right"></i>
                </button>
              </div>
            </div>
            <div className="col-md-3">
              <label className="form-label">&nbsp;</label>
              <button
                className="btn btn-outline-secondary w-100 d-block"
                onClick={goToToday}
              >
                <i className="ti ti-calendar-today me-1"></i>Today
              </button>
            </div>
          </div>

          {/* Quick Stats */}
          <div className="row mb-4">
            <div className="col-md-3 col-sm-6">
              <div className="card bg-primary-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-md bg-primary mb-2">
                    <i className="ti ti-book text-white"></i>
                  </div>
                  <h5 className="text-primary">25</h5>
                  <p className="mb-0">Classes/Week</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-warning-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-md bg-warning mb-2">
                    <i className="ti ti-clock text-white"></i>
                  </div>
                  <h5 className="text-warning">6.5</h5>
                  <p className="mb-0">Hours/Day</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-info-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-md bg-info mb-2">
                    <i className="ti ti-calendar-event text-white"></i>
                  </div>
                  <h5 className="text-info">8</h5>
                  <p className="mb-0">Subjects</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-success-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-md bg-success mb-2">
                    <i className="ti ti-users text-white"></i>
                  </div>
                  <h5 className="text-success">9</h5>
                  <p className="mb-0">Teachers</p>
                </div>
              </div>
            </div>
          </div>

          {/* Schedule Content */}
          {viewType === "daily"
            ? renderDailySchedule()
            : renderWeeklySchedule()}
        </div>
      </div>
    </>
  );
};

export default ParentSchedule;
